import React, { useState, useEffect } from "react";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import SearchBar from "./components/SearchBar";
import TableOfViewECs from "./components/TableOfViewECs";
import { Get_limited_From_MongoDB } from "../../../api/Get_limited_From_MongoDB";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";

import GetClientAddress from "../../../../functions/GetClientAddress";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function ViewECs() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [ECs, setECs] = useState([]);
  //The below is the useEffect to fetch data from the backend
  useEffect(() => {
    Get_limited_From_MongoDB("IP", "EC", 20, setECs, logout);
  }, []);

  // let EC_Plus_Link = the array EC where every object is also given {Link: "/Staff/ViewEC/EC_id"}
  let EC_Plus_Link = ECs.map((EC) => {
    return {
      ...EC,
      Link: `${GetClientAddress()}Public/RegistrationForm/${EC._id}`,
    };
  });

  let EC_Plus_Link_Flattened = EC_Plus_Link.map((One_EC) => {
    return deepFlattenToObject(One_EC);
  });

  //-----------------------------Components--------------------------------------------

  //-----------------------------Return--------------------------------------------

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <SearchBar setECs={setECs} />
        <DisplayExport excelData={EC_Plus_Link_Flattened} fileName="ECs_Data" />
        <TableOfViewECs ECs={ECs} />
      </div>
    </div>
  );
}

export default ViewECs;
